import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography/Typography';
import { colors } from 'styles';

export const CardType = styled(Typography)`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${colors.mainDark};
`;

export const CardTitle = styled(Typography)`
  margin: 8px 0;
  font-weight: 700;
  line-height: 140%;
  color: ${colors.mainDark};
  font-size: 24px;
`;

export const CardDescription = styled(Typography)`
  font-size: 16px;
  line-height: 150%;
  color: ${colors.mainDark};
`;

export const CardText = styled(Typography)`
  font-size: 14px;
  line-height: 150%;
  color: ${colors.mainDark};
`;
